import { useState } from 'react';
import './App.css';
import Navbar from './Components/Navbar';
import NewsBoard from './Components/NewsBoard';

function App() {

  const [category, setCategory] = useState("general");
  const [country, setCountry] = useState("us");

  return (
    <div className="App">
      <Navbar setCategory={setCategory} setCountry={setCountry} currentCountry={country} />
      <NewsBoard category={category} country={country} />
    </div>
  );
}

export default App;
